import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { clinicRevenueChannelsDataSource } from 'infrastructure/data-sources/clinic-revenue-channels';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IClinicRevenueChannelItem } from 'infrastructure/data-sources/clinic-revenue-channels';

type Options = IBaseSelectBoxOption<
  IClinicRevenueChannelItem['id'],
  IClinicRevenueChannelItem
>[];

interface IClinicRevenueChannelSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicRevenueChannelSelectBox: React.FC<
  IClinicRevenueChannelSelectBoxProps
> = (props) => {
  const dataSource = useMemo(() => clinicRevenueChannelsDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicRevenueChannelSelectBox;
